export const CLEAR_FAQ = 'CLEAR_FAQ';
export const CLEAR_STATE = 'CLEAR_STATE';

export const DELETE_FAQ = 'DELETE_FAQ';
export const DELETE_FAQ_ERROR = 'DELETE_FAQ_ERROR';
export const DELETE_FAQ_SUCCESS = 'DELETE_FAQ_SUCCESS';

export const GET_FAQS = 'GET_FAQS';
export const GET_FAQS_ERROR = 'GET_FAQS_ERROR';
export const GET_FAQS_SUCCESS = 'GET_FAQS_SUCCESS';

export const GET_FAQ = 'GET_FAQ';
export const GET_FAQ_ERROR = 'GET_FAQ_ERROR';
export const GET_FAQ_SUCCESS = 'GET_FAQ_SUCCESS';

export const SAVE_FAQ = 'SAVE_FAQ';
export const SAVE_FAQ_ERROR = 'SAVE_FAQ_ERROR';
export const SAVE_FAQ_SUCCESS = 'SAVE_FAQ_SUCCESS';



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Information/FAQs/constants.js